/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-02-24",
    versionChannel: "nightly",
    buildDate: "2025-02-24T00:06:49.901Z",
    commitHash: "c81da3f1fd07abe66e1d5f1a2a74c8d9cebfce34",
};
